import {
  DetailRow,
  ImageGallery,
  MapEmbed,
} from "../../../../components/admin/common/details-components";
import { formatPrettyAddress, formatPrice } from "../../../../utils/helpers";

const PropertyDetailsCard = ({ property }) => {
  const prop = property?.property || {};
  const priceAmount = formatPrice(prop?.expectedPrice);

  return (
    <div className="p-6 flex flex-col space-y-2">
      {/* Location */}
      <span>{formatPrettyAddress(property?.location)}</span>

      {/* Title */}
      <h2 className="text-[1.25rem] sm:text-[1.35rem] font-semibold leading-snug text-text-primary mb-2">
        {prop?.carpetArea?.value || "—"} Sqft. Plot in{" "}
        {property?.location?.address?.locality ||
          property?.location?.address?.city}
      </h2>

      {/* Listing ID */}
      <div className="text-text-secondary text-sm mb-3">
        Listing ID: {property?._id || "N/A"}
      </div>

      {/* Price */}
      <div className="text-primary-navy text-2xl font-semibold mb-2 tracking-normal">
        {priceAmount}
      </div>

      {/* Plot Area */}
      <div className="text-text-secondary text-sm">
        <span className="font-semibold text-text-primary">Plot Area:</span>{" "}
        {prop?.carpetArea?.value
          ? `${prop.carpetArea.value} ${prop.carpetArea.unit || "sqft"}`
          : "Not specified"}
      </div>
    </div>
  );
};

const MoreDetailsCard = ({ property }) => {
  const prop = property?.property || {};
  const priceAmount = formatPrice(prop?.expectedPrice);

  const pricePerSqft = prop?.pricePerSqft
    ? `${prop.pricePerSqft} per sqft`
    : "—";

  return (
    <div className="bg-white rounded-xl shadow-sm p-4 sm:p-6 w-full">
      <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-gray-900 mb-3">
        More Details
      </h3>

      <div className="space-y-3">
        <DetailRow label="Price" value={`${priceAmount} (${pricePerSqft})`} />

        <DetailRow label="Open Sides" value={prop?.noOfOpenSides || "—"} />
        <DetailRow
          label="Floors Allowed For Construction"
          value={prop?.floorsAllowedForConstruction || "—"}
        />
        <DetailRow
          label="Width Of Road Facing"
          value={(() => {
            const w = prop?.widthOfRoadFacing;

            if (w && typeof w === "object" && "value" in w && "unit" in w) {
              return `${w.value} ${w.unit}`;
            }

            if (typeof w === "number") {
              return `${w} sqft`;
            }

            return "N/A";
          })()}
        />
        <DetailRow
          label="Pre-leased"
          value={prop?.isPreleasedProperty ? "Yes" : "No"}
        />
        <DetailRow
          label="Address"
          value={
            property?.location?.address?.formatted ||
            formatPrettyAddress(property?.location) ||
            "—"
          }
        />
      </div>
    </div>
  );
};

const AdminLandPropertyDetails = ({ property }) => {
  return (
    <div className="min-h-screen bg-background font-poppins">
      <main className="max-w-full mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-6">
          {/* Left Column - Images & Map */}
          <div className="xl:col-span-2 space-y-4">
            <ImageGallery images={property?.images} title={property?.title} />
            <MapEmbed
              className="h-[25rem]"
              coordinates={property?.location?.coordinates}
              address={formatPrettyAddress(property?.location)}
            />
          </div>

          {/* Right Column - Details */}
          <div className="space-y-4">
            <PropertyDetailsCard property={property} />
            <MoreDetailsCard property={property} />
          </div>
        </div>
      </main>
    </div>
  );
};

export default AdminLandPropertyDetails;
